import { render, staticRenderFns } from "./EditUserProfileDialog.vue?vue&type=template&id=0d10fd0e&scoped=true"
import script from "./EditUserProfileDialog.vue?vue&type=script&lang=ts"
export * from "./EditUserProfileDialog.vue?vue&type=script&lang=ts"
import style0 from "./EditUserProfileDialog.vue?vue&type=style&index=0&id=0d10fd0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d10fd0e",
  null
  
)

export default component.exports